import { createAction, props } from '@ngrx/store'

export const httpErrorInterceptorActions = createAction(
    '[httpErrorInterceptorActions] token HttpErrorInterceptor',
    props<{ httpErrorInterceptor: any }>()
)